export default __webpack_public_path__ + "static/media/youtube-icon.423e45a7.svg";